module.exports = __webpack_public_path__ + "59fe3ba3531932ab2c7ed1a340f9b675.png";